/**
 * Razvan Garage – filtrele lungi ca o caseta cu lista care se deschide sub ea.
 *
 * Pentru "Tip produs", "Marcă", "Compatibil cu", "Model compatibil", "Vascozitate", "Amperaj" si filtrele din
 * lotul de la 31.10 (soclu, tehnologie, tensiune, poziție, parte, culoare, tip antigel, suspensie, dimensiune, sezon):
 * - Lista nu mai sta desfasurata sub filtru: se vad doar caseta si valorile deja bifate.
 * - Clic sau scris in caseta: sub ea se deschide lista, cu derulare; cateva litere ("mo", "gol",
 *   "5w30") lasa doar valorile care le contin oriunde ("mo" -> "Suport motor", "Amortizor").
 *   Bifa se pune din lista, ca pana acum.
 * - Lista se inchide la clic in afara ei sau la Esc.
 * - Tastarea nu porneste filtrarea magazinului; doar bifa o porneste.
 * - Cand la "Compatibil cu" e bifata o marca (Audi), la "Model compatibil" raman doar modelele ei
 *   (A1, A3, A4...), chiar daca produsele afisate se potrivesc si la alte marci. Legatura model ->
 *   marca e in rg-modele-marci.json (din acordeoanele produselor; adresa vine din data-modele).
 * - La "Amperaj" valorile stau in ordinea numerelor (44 Ah inainte de 100 Ah), nu alfabetic.
 * - La cautare (03.11), la "Tip produs" tipurile stau dupa numarul de produse, cel mai mare primul.
 * - La "An fabricație" (04.11) anii stau de la cel mai nou la cel mai vechi.
 * - Dupa fiecare bifa tema redeseneaza filtrele, asa ca casetele se pun din nou.
 */
(() => {
  if (window.rgFiltruCautare) return;

  const adresaHarta = document.currentScript && document.currentScript.dataset.modele;
  let harta = null; // id marca -> Set(id model)
  const laHarta = [];
  if (adresaHarta) {
    fetch(adresaHarta)
      .then((r) => (r.ok ? r.json() : null))
      .then((date) => {
        if (!date) return;
        harta = new Map(Object.entries(date).map(([marca, modele]) => [marca, new Set(modele.map(String))]));
        laHarta.splice(0).forEach((fn) => fn());
      })
      .catch(() => {
        // Fara legatura: lista de modele ramane intreaga.
      });
  }
  const idScurt = (gid) => String(gid || '').split('/').pop();

  /** Modelele permise de marcile bifate la "Compatibil cu" (null = fara restrictie). */
  function modelePermise() {
    if (!harta) return null;
    const bifate = [...document.querySelectorAll('input[name="filter.p.m.custom.marci_compatibile"]:checked')]
      .map((i) => idScurt(i.value));
    if (!bifate.length) return null;
    const permise = new Set();
    bifate.forEach((m) => (harta.get(m) || []).forEach((id) => permise.add(id)));
    return permise;
  }

  const FILTRE = {
    'filter.p.m.custom.tip_produs_unic': 'Caută tipul produsului…',
    'filter.p.vendor': 'Caută marca…',
    'filter.p.m.custom.marci_compatibile': 'Caută marca mașinii…',
    'filter.p.m.custom.modele_compatibile': 'Caută modelul…',
    'filter.p.m.custom.vascozitate': 'Caută vâscozitatea…',
    'filter.p.m.custom.amperaj': 'Caută amperajul…',
    'filter.p.m.custom.soclu_bec': 'Caută soclul…',
    'filter.p.m.custom.tehnologie_bec': 'Caută tehnologia…',
    'filter.p.m.custom.tensiune': 'Caută tensiunea…',
    'filter.p.m.custom.pozitie': 'Caută poziția…',
    'filter.p.m.custom.parte': 'Caută partea…',
    'filter.p.m.custom.culoare': 'Caută culoarea…',
    'filter.p.m.custom.tip_antigel': 'Caută tipul de antigel…',
    'filter.p.m.custom.suspensie': 'Caută suspensia…',
    'filter.p.m.custom.dimensiune': 'Caută dimensiunea…',
    'filter.p.m.custom.sezon': 'Caută sezonul…',
    'filter.p.m.custom.an_fabricatie': 'Caută anul…',
  };
  const MIN_VALORI = 1;
  const MODELE = 'filter.p.m.custom.modele_compatibile';
  const AMPERAJ = 'filter.p.m.custom.amperaj';
  const AN = 'filter.p.m.custom.an_fabricatie';
  const TIP = 'filter.p.m.custom.tip_produs_unic';

  const norm = (text) => (text || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  const compact = (text) => text.replace(/[^a-z0-9]/g, '');

  const stil = document.createElement('style');
  stil.textContent = `
    .rg-filtru-cautare{display:block;width:100%;box-sizing:border-box;margin:0 0 8px;padding:9px 34px 9px 10px;
      font:inherit;font-size:14px;border:1px solid rgba(0,0,0,.25);border-radius:6px;color:inherit;cursor:pointer;
      background:#fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24'%3E%3Cpath d='M20 8.5 12.5 16 5 8.5' stroke='%23555' stroke-width='2' fill='none'/%3E%3C/svg%3E") no-repeat right 12px center}
    .rg-filtru-cautare:focus{outline:2px solid rgba(0,0,0,.35);outline-offset:1px;cursor:text}
    .rg-filtru-lista li.rg-filtru-gasit{display:block!important}
    .rg-filtru-lista li.rg-filtru-ascuns{display:none!important}
    .rg-filtru-lista.rg-filtru-deschis{max-height:280px;overflow-y:auto;overscroll-behavior:contain;margin:-4px 0 10px;
      padding:6px 10px;border:1px solid rgba(0,0,0,.2);border-radius:6px;background:#fff;box-shadow:0 6px 16px rgba(0,0,0,.12)}
    .rg-filtru-nimic{margin:0 0 10px;font-size:14px;opacity:.7}
  `;
  document.head.append(stil);

  /**
   * Transforma un filtru intr-o caseta cu lista (o singura data pentru fiecare lista desenata).
   * @param {HTMLDetailsElement} det - Filtrul ("details.filter").
   */
  function pregateste(det) {
    const numeFiltru = det.id.replace(/^filter-/, '');
    const text = FILTRE[numeFiltru];
    const lista = det.querySelector('.filter__content ul');
    if (!text || !lista || lista.dataset.rgCautare) return;
    const randuri = [...lista.children].filter((li) => li.tagName === 'LI');
    if (randuri.length < MIN_VALORI) return;
    lista.dataset.rgCautare = '1';
    lista.classList.add('rg-filtru-lista');

    if (numeFiltru === AMPERAJ) {
      const ah = (li) => parseFloat((li.querySelector('label .flex-auto') || li).textContent) || 0;
      randuri.sort((a, b) => ah(a) - ah(b)).forEach((li) => lista.append(li));
    }

    // La "An fabricație" anii stau de la cel mai nou la cel mai vechi.
    if (numeFiltru === AN) {
      const an = (li) => parseInt((li.querySelector('label .flex-auto') || li).textContent, 10) || 0;
      randuri.sort((a, b) => an(b) - an(a)).forEach((li) => lista.append(li));
    }

    // La cautare, tipurile cu cele mai multe produse stau primele (ca la eMAG); la egalitate ramane ordinea alfabetica.
    if (numeFiltru === TIP && /\/search/.test(window.location.pathname)) {
      const nr = (li) => parseInt(((li.querySelector('.filter__count') || {}).textContent || '').replace(/\D/g, ''), 10) || 0;
      randuri.sort((a, b) => nr(b) - nr(a)).forEach((li) => lista.append(li));
    }

    const camp = document.createElement('input');
    camp.type = 'search';
    camp.className = 'rg-filtru-cautare';
    camp.placeholder = text;
    camp.autocomplete = 'off';
    camp.setAttribute('aria-label', text);
    camp.setAttribute('aria-expanded', 'false');
    lista.before(camp);

    const nimic = document.createElement('p');
    nimic.className = 'rg-filtru-nimic';
    nimic.textContent = 'Nu am găsit nimic.';
    nimic.hidden = true;
    lista.after(nimic);

    // "Afișați mai multe" nu mai are rost: lista se deschide intreaga sub caseta ("Șterge" ramane).
    const maiMulte = det.querySelector('.js-show-more');
    if (maiMulte) maiMulte.style.display = 'none';

    // data-rg-nume = numele din admin, cand pe site valoarea apare altfel ("acumulator" gaseste "Baterie auto și tractor").
    const etichete = randuri.map((li) => {
      const nume = li.querySelector('label .flex-auto') || li;
      return norm(`${nume.textContent} ${nume.dataset.rgNume || ''}`);
    });
    let deschis = false;

    const arata = () => {
      const q = norm(camp.value);
      const qc = compact(q);
      const permise = numeFiltru === MODELE ? modelePermise() : null;
      let gasite = 0;
      randuri.forEach((li, i) => {
        const e = etichete[i];
        const intrare = li.querySelector('input');
        const bifat = Boolean(intrare && intrare.checked);
        const dinMarca = !permise || bifat || permise.has(idScurt(intrare && intrare.value));
        const potrivit = dinMarca && (!q || e.includes(q) || (qc && compact(e).includes(qc)));
        const vizibil = deschis ? potrivit : bifat;
        li.classList.toggle('rg-filtru-gasit', vizibil);
        li.classList.toggle('rg-filtru-ascuns', !vizibil);
        if (deschis && potrivit) gasite += 1;
      });
      lista.classList.toggle('rg-filtru-deschis', deschis);
      camp.setAttribute('aria-expanded', String(deschis));
      nimic.hidden = !(deschis && gasite === 0);
    };

    const deschide = () => {
      if (deschis) return;
      deschis = true;
      lista.scrollTop = 0;
      arata();
    };
    const inchide = () => {
      if (!deschis) return;
      deschis = false;
      arata();
    };

    camp.addEventListener('focus', deschide);
    camp.addEventListener('click', deschide);
    // Tema filtreaza la orice schimbare din formular: caseta noastra nu trebuie sa ajunga la ea.
    ['input', 'change', 'keyup'].forEach((tip) => camp.addEventListener(tip, (evt) => {
      evt.stopPropagation();
      if (tip === 'input') {
        deschis = true;
        lista.scrollTop = 0;
        arata();
      }
    }));
    camp.addEventListener('keydown', (evt) => {
      evt.stopPropagation();
      if (evt.key === 'Enter') evt.preventDefault();
      if (evt.key === 'Escape') {
        inchide();
        camp.blur();
      }
    });
    // "In afara" se judeca la apasare: cand lista se deschide, coloana se poate misca sub cursor,
    // iar evenimentul "click" ar ajunge la alt element si ar inchide-o imediat.
    document.addEventListener('pointerdown', (evt) => {
      if (!deschis || !lista.isConnected) return;
      if (evt.target === camp || lista.contains(evt.target)) return;
      inchide();
    });

    arata();
    if (numeFiltru === MODELE && !harta && adresaHarta) laHarta.push(arata);
  }

  let asteapta = null;
  const toate = () => {
    asteapta = null;
    document.querySelectorAll('details.filter[id^="filter-filter."]').forEach(pregateste);
  };
  new MutationObserver(() => {
    if (!asteapta) asteapta = requestAnimationFrame(toate);
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.rgFiltruCautare = { pregateste };
  toate();
})();
